import { connect } from 'react-redux';
import { get } from 'lodash-es';
import { emptyArray } from 'ui-components/default-props/empty';
import { SingleOrderCSW } from '../../../components/orders-drawer/sections/single-order-csw';
import Global from '../../../store/global-selectors';
import { openAddSalesOrderToBatchFromOrdersGrid } from '../../../store/orders/grid/orders.grid.header.actions';
import { FulfillmentPlanService } from '../../../services/fulfillment-plan-service/';
import { getActualFulfillmentPlanIds, getActualSalesOrderIds } from '../../../store/orders/orders.helpers';
import { OrderDrawerSection } from '../../../enums/order-drawer-section';

import { mapDispatchToOnClick, mapStateToOpen } from './section-container-helper';
import * as OrderActions from '../../../store/orders/orders.actions';

const sectionId = OrderDrawerSection.order;

const mapStateToProps = (state, { currentFulfillmentPlanId }) => {
  const selectedIds = Global.selectSelectedOrdersIds(state);
  const actualFulfillmentPlanIds = getActualFulfillmentPlanIds(state, selectedIds) || emptyArray;
  const salesOrderIds = getActualSalesOrderIds(state, actualFulfillmentPlanIds) || emptyArray;
  const order = Global.selectEntitiesSalesOrdersByIds(state, { salesOrderIds })[0] || {};
  const fulfillmentPlan = Global.selectEntitiesFulfillmentPlanById(state, {
    fulfillmentPlanId: actualFulfillmentPlanIds[0],
  });
  const { isCancelled, isAwaitingPayment, shouldShowCompletedIndicator, shouldShowShipmentWidget } =
    FulfillmentPlanService.getFulfillmentPlanMetadata(fulfillmentPlan);
  const orderItems = get(fulfillmentPlan, 'items', emptyArray);
  const pendingFulfillmentPlanId = currentFulfillmentPlanId || actualFulfillmentPlanIds[0];
  const isCreatingReturn = Global.selectOrderDetailsIsCreatingReturn(state);
  const fulfillmentPlanId = isCreatingReturn
    ? Global.selectOrdersDrawerReturnsFulfillmentPlanId(state, {
        salesOrderId: salesOrderIds[0],
      })
    : pendingFulfillmentPlanId;

  return {
    order,
    salesOrderId: salesOrderIds[0],
    fulfillmentPlanId,
    orderItems,
    isCreatingReturn,
    ...mapStateToOpen(state, sectionId),
    isCancelled,
    isAwaitingPayment,
    shouldShowCompletedIndicator,
    shouldShowShipmentLink: shouldShowCompletedIndicator,
    shipmentLinkFulfillmentPlanId: fulfillmentPlanId,
    shouldShowOrderItems: shouldShowCompletedIndicator,
    shouldShowShipmentWidget,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ...mapDispatchToOnClick(dispatch, sectionId),
    openAddOrderToBatchModal: () => dispatch(openAddSalesOrderToBatchFromOrdersGrid()),
    restore: (fulfillmentPlanId) => dispatch(OrderActions.requestRestoreFulfillments(fulfillmentPlanId)),
  };
};

export const ConfigureShipmentSectionContainer = connect(mapStateToProps, mapDispatchToProps);

export const SingleOrderCsw = ConfigureShipmentSectionContainer(SingleOrderCSW);
